import React from 'react';

const ClientDetailsModal = ({ isOpen, client, onClose }) => {
  if (!isOpen || !client) return null;
  console.log('Client data in modal:', client);

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
      <div className="relative top-10 mx-auto p-5 border w-full max-w-4xl shadow-lg rounded-md bg-white">
        <div className="mt-3">
          <div className="flex items-center justify-between mb-6">
            <h3 className="text-xl font-semibold text-gray-900">Client Details</h3>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600"
            >
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-1 gap-6">
            {/* Basic Information */}
            <div className="mb-8">
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <p className="text-sm text-gray-500">Client Name</p>
                  <p className="font-medium">{client.clientName}</p>
                </div>
                {client.clientAddress && (
                  <div>
                    <p className="text-sm text-gray-500">Client Address</p>
                    <p className="font-medium">{client.clientAddress}</p>
                  </div>
                )}
                {client.contactPersons && client.contactPersons.length > 0 && (
                  <div className="md:col-span-2">
                    <p className="text-sm text-gray-500 mb-2">Contact Persons</p>
                    <div className="space-y-2">
                      {client.contactPersons.map((contact, index) => (
                        <div key={index} className="text-sm">
                          <span className="font-medium">{contact.title} {contact.name}</span>
                          <span className="text-gray-600"> - {contact.email}</span>
                          {contact.phoneNumbers && contact.phoneNumbers.length > 0 && (
                            <span className="text-gray-600"> ({contact.phoneNumbers.join(', ')})</span>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                {client.authorizedSignatories && client.authorizedSignatories.length > 0 && (
                  <div className="md:col-span-2">
                    <p className="text-sm text-gray-500 mb-2">Authorized Signatories</p>
                    <div className="space-y-2">
                      {client.authorizedSignatories.map((signatory, index) => (
                        <div key={index} className="text-sm">
                          <span className="font-medium">{signatory.title} {signatory.name}</span>
                          {signatory.age && (
                            <span className="text-gray-600"> (Age: {signatory.age})</span>
                          )}
                          {signatory.designation && (
                            <span className="text-gray-600"> - {signatory.designation}</span>
                          )}
                          {signatory.designationName && (
                            <span className="text-gray-600"> - {signatory.designationName}</span>
                          )}
                          {signatory.fatherName && (
                            <span className="text-gray-600"> - Son of {signatory.fatherName}</span>
                          )}
                          {signatory.email && (
                            <div className="text-xs text-gray-500 mt-1">Email: {signatory.email}</div>
                          )}
                          {signatory.phone && (
                            <div className="text-xs text-gray-500">Phone: {signatory.phone}</div>
                          )}
                          {signatory.address && (
                            <div className="text-xs text-gray-500">Address: {signatory.address}</div>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientDetailsModal;